<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/customer-supplies/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New customer supply
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'customer-supply'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/customer-supplies`"
    />
  </v-container>
</template>

<script>
export default {
  name: "CustomerSupplyList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Customer name', value: 'biz_customer_name' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['biz_customer_name'],
    search_param: '',
    attribute_list: ['id', 'biz_customer_name'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
